import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-footer',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './footer.component.html',
  standalone: true,
  imports: [CommonModule, RouterLink],
})
export class FooterComponent {
  @Input() isPublic = false;

  currYear = new Date().getFullYear();
}
